export default class ActiveRegion {
    // Public:
    constructor(nodes) {
        this._nodes = nodes;
    }

    compute() {
        this.computeEvelopeCorners();
        this.computeCenter();
        this.computeDimensions();
    }

    getCenter() {
        return this._center;
    }

    getWidth() {
        return this._width;
    }

    getHeight() {
        return this._height;
    }

    // Private:
    computeEvelopeCorners() {
        let xMin = Infinity;
        let xMax = -Infinity;
        let yMin = Infinity;
        let yMax = -Infinity;
        let nodes = this._nodes;
        nodes.forEach(node => {
            const x = node.x;
            const y = node.y;
            const R = node.radius;
            if (x - R < xMin) xMin = x - R;
            if (x + R > xMax) xMax = x + R;
            if (y - R < yMin) yMin = y - R;
            if (y + R > yMax) yMax = y + R;
        });
        this._P0 = {
            x: xMin,
            y: yMin,
        };
        this._P1 = {
            x: xMax,
            y: yMax,
        };
    }

    computeCenter() {
        let P0 = this._P0;
        let P1 = this._P1;
        let center = {
            x: (P0.x + P1.x) / 2,
            y: (P0.y + P1.y) / 2,
        };
        this._center = center;
    }

    computeDimensions() {
        let P0 = this._P0;
        let P1 = this._P1;
        let w = P1.x - P0.x;
        let h = P1.y - P0.y;
        this._width = w;
        this._height = h;
    }
}
